import {
  identifyMixpanelUser,
  initMixpanel,
  trackEvent as trackMixpanelEvent,
} from '../util/mixpanel';
export class LoggingAnalyticsHandler {
  trackPageView(url) {}
}
// Google Analytics 4 (GA4) using gtag.js script, which is included in util/includeScripts.js
export class GoogleAnalyticsHandler {
  trackPageView(canonicalPath, previousPath) {
    // GA4 property. Manually send page_view events
    // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    // Note 1: You should turn "Enhanced measurement" off.
    //         It attaches own listeners to elements and that breaks in-app navigation.
    // Note 2: If previousPath is null (just after page load), gtag script sends page_view event automatically.
    //         Only in-app navigation needs to be sent manually from SPA.
    // Note 3: Timeout is needed because gtag script picks up <title>,
    //         and location change event happens before initial rendering.
    if (previousPath && window.gtag) {
      window.setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: canonicalPath,
        });
      }, 300);
    }
  }
}
// MixPanel analytics class to track user actions
class MixPanelAnalyticsHandler {
  constructor() {}
  initialize() {
    initMixpanel();
  }
  identifyUser(userId) {
    if (!userId) {
      return;
    }

    identifyMixpanelUser({
      id: { uuid: userId },
      attributes: {
        email: '',
        profile: {},
      },
    });
  }
  setUserData(user = {}) {
    const sharetribeUserId = user.sharetribeUserId || user.userId || user.id;

    if (!sharetribeUserId) {
      return;
    }

    identifyMixpanelUser({
      id: { uuid: sharetribeUserId },
      attributes: {
        email: user.email || '',
        profile: {
          firstName: user.firstName || '',
          lastName: user.lastName || '',
        },
        publicData: {
          fullName: user.fullName || '',
        },
      },
    });
  }
  trackEvent(eventName, properties = {}) {
    trackMixpanelEvent(eventName, properties);
  }
}
export const mixPanelAnalytics = new MixPanelAnalyticsHandler();
